import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { useMediaQuery } from "usehooks-ts";
import dayjs from "dayjs";

export const SellarCreditStatementStats = ({
  statement,
  dueDate,
  total,
  status,
}: {
  statement: ReactNode;
  dueDate: Date | null;
  total: ReactNode;
  status: ReactNode;
}) => {
  const formattedDueDate = dayjs(dueDate).format("MMMM D, YYYY");

  const isDesktop = useMediaQuery("(min-width: 1200px)");

  return (
    <div
      className={twMerge(
        "flex w-full items-center divide-x overflow-x-auto bg-white py-4 md:mt-6",
        isDesktop && "rounded-lg border border-zinc-300",
      )}
    >
      <StatItem title="Statement">
        <span className="text-xl text-nowrap">{statement}</span>
      </StatItem>
      <StatItem title="Due date">
        <span className="text-xl text-nowrap">{formattedDueDate}</span>
      </StatItem>
      <StatItem title="Total to pay">
        <span className="text-xl text-nowrap">{total}</span>
      </StatItem>
      <StatItem title="Payment status">
        <span className="text-xl text-nowrap">{status}</span>
      </StatItem>
    </div>
  );
};

const StatItem = ({
  children,
  title,
}: {
  children: ReactNode;
  title: string;
}) => {
  return (
    <div className="flex flex-1 flex-col gap-2 px-4">
      <span className="flex items-center text-xs font-semibold text-nowrap">
        {title}
      </span>
      {children}
    </div>
  );
};
